<script lang="ts" setup>
export interface WidgetSocialProps {
    data: Socials
}
const props = defineProps<WidgetSocialProps>()
</script>

<template>
  <section data-cy="widget_socials">
    <Tracker :data="{ position: props.data.title }">
      <BoxHeader
        :heading="props.data.title"
        heading-level="h2"
        :subtitle="props.data.subtitle"
        class="mb-3 mb-md-6"
      >
        <template #tag>
          <Tag
            size="small"
            background-color="gray-1"
            class="text-uppercase"
          >
            {{ props.data.tag }}
          </Tag>
        </template>
      </BoxHeader>
      <div class="d-flex justify-content-center gap-5">
        <SocialButtons :data="props.data.data" />
      </div>
    </Tracker>
  </section>
</template>
